export enum AlertState {
  Invisible = 'invisible',
  Visible = 'visible',
  Destroyed = 'destroyed',
}
